<footer id="footer-component" class="w-100">
    <!-- footer-cms -->
    <cms [title]="cmsTitle" #cmsComp></cms>
    <section #containerRef [hidden]="true">
        <ng-container>
            <newsletter></newsletter>
        </ng-container>
    </section>
    <!-- end footer-cms -->
</footer>
